<template>
  <content-box class="encourage-plan--wrap" :class="{ 'is-layer': isLayer }" :width="'770px'">
    <h2><i class="icon icon--logo-new"></i></h2>
    <template v-if="dashboardState === 'firstLogin'">
      <p class="title" v-html="$t('dashboard.encouragePlan.default.title')"></p>
      <ui-button class="btn__confirm"
        :backgroundColor="'#ec0047'"
        :primary="true"
        :size="'large'"
        @click="$emit('onCloseLayer')">{{ $t('dashboard.encouragePlan.default.button') }}</ui-button>
      <p class="desc"></p>
    </template>
    <template v-else-if="dashboardState === 'noPage-plan-noCredit'">
      <p class="title">{{ $t('dashboard.encouragePlan.creditEmpty.title') }}</p>
      <p class="desc2" v-html="$t('dashboard.encouragePlan.creditEmpty.desc')"></p>
      <div class="btn__wrap">
        <ui-button :backgroundColor="'#ec0047'"
                   :primary="true"
                   @click="$router.push({ name: 'managePlan', params: { action: 'changePlan' } })">
          {{ $t('common.upgradePlan') }}
        </ui-button>
        <ui-button :backgroundColor="'#1199af'"
                   :primary4="true"
                   :iconName="'icon--pv-plug'"
                   :disabled="$i18n.locale === 'ja'"
                   @click="$router.push({ name: 'managePlan', params: { action: 'chargePv' } })">
          {{ $t('common.chargePv') }}
        </ui-button>
      </div>
    </template>
    <template v-else-if="dashboardState === 'noPage-noPlan'">
      <p class="title" v-html="$t('dashboard.encouragePlan.noPlan.title')"></p>
      <ui-button class="btn__confirm"
        :backgroundColor="'#ec0047'"
        :primary="true"
        :size="'large'"
        @click="$router.push({ name: 'managePlan', params: { action: 'createPlan' } })">
        {{ $t('common.subscribeYourPlan') }}
      </ui-button>
    </template>
    <div class="carousel--wrap">
      <swiper :options="swiperOption" ref="swiperWrap">
        <swiper-slide class="list1">
          <!-- spec out
          <a href="" target="_blank" class="move-guide">
            {{ $t('common.registrationGuide') }}
            <i class="icon icon--link-size16"></i>
          </a>
          -->
          <div class="carousel__content">
            <figure class="content__img" :class="$i18n.locale">
            </figure>
            <div class="content__desc">
              <p class="title" v-html="$t('dashboard.encouragePlan.pagination.step1.title')"></p>
              <p class="desc" v-html="$t('dashboard.encouragePlan.pagination.step1.desc')"></p>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide class="list2">
          <!-- spec out
          <a href="" target="_blank" class="move-guide">
            {{ $t('common.trackingCodeInstallationGuide') }}
            <i class="icon icon--link-size16"></i>
          </a>
          -->
          <div class="carousel__content">
            <figure class="content__img" :class="$i18n.locale">
            </figure>
            <div class="content__desc">
              <p class="title">{{ $t('dashboard.encouragePlan.pagination.step2.title') }}</p>
              <p class="desc" v-html="$t('dashboard.encouragePlan.pagination.step2.desc')"></p>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide class="list3">
          <div class="carousel__content">
            <figure class="content__img" :class="$i18n.locale">
            </figure>
            <div class="content__desc">
              <p class="title">{{ $t('dashboard.encouragePlan.pagination.step3.title') }}</p>
              <p class="desc" v-html="$t('dashboard.encouragePlan.pagination.step3.desc')"></p>
            </div>
          </div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination" ref="pagination"></div>
        <div class="swiper-button-prev icon icon--prev-white-size20" slot="button-prev"></div>
        <div class="swiper-button-next icon icon--prev-white-size20" slot="button-next"></div>
      </swiper>
    </div>
    <i v-if="isLayer" class="icon icon--close-btn" @click="$emit('onCloseLayer')"></i>
  </content-box>
</template>

<script>
import UiButton from '@/components/ui/UiButton'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import ContentBox from '@/components/ui/ContentBox'

export default {
  components: {
    UiButton,
    swiper,
    swiperSlide,
    ContentBox
  },
  props: [
    'dashboardState'
  ],
  data () {
    return {
      swiperOption: {
        slidesPerView: 1,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  computed: {
    isLayer () {
      return this.dashboardState === 'firstLogin'
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
.encourage-plan--wrap {
  padding: 30px;
  box-sizing: border-box;
  @include positionXYcenter;

  .icon--close-btn {
    position: absolute;
    top: 0;
    right: 0;
    padding: 12px;
    background-position: center;
  }

  & > .title {
    margin-top: 48px;
    font-size: 36px;
    font-weight: bold;
    color: #555555;
    line-height: 1.33;
    text-align: center;
  }

  & > .desc {
    margin-top: 10px;
    text-align: center;
    font-size: 14px;
    height: 14px;
    color: $brandColor;
  }

  & > .desc2 {
    text-align: center;
    margin-top: 10px;
    padding-left: 10px;
    font-size: 24px;
    color: #555;
  }

  .btn__confirm {
    display: block;
    margin: 30px auto 0;
  }

  .btn__wrap {
    display: block;
    margin: 30px auto 0;
    text-align: center;

    button {
      margin: 0 2.5px;
    }
  }

  .carousel--wrap {
    @include carouselContent;
    margin-top: 20px;
    width: 100%;
    height: 300px;
    border-radius: 5px;
    background-color: #2f2f2f;

    /deep/ .swiper-slide {
      .content__img {
        width: 288px;
        height: 180px;
        background-size: cover;
      }
    }

    .list1 {
      .content__img {
        &.ko {
          background-image: url(../../assets/img/dashboard/free_trial_ko1.png);
        }
        &.ja {
          background-image: url(../../assets/img/dashboard/free_trial_ja1.png);
        }
        &.en {
          background-image: url(../../assets/img/dashboard/free_trial_en1.png);
        }
      }
    }

    .list2 {
      .content__img {
        &.ko {
          background-image: url(../../assets/img/dashboard/free_trial_ko2.png);
        }
        &.ja {
          background-image: url(../../assets/img/dashboard/free_trial_ja2.png);
        }
        &.en {
          background-image: url(../../assets/img/dashboard/free_trial_en2.png);
        }
      }
    }

    .list3 {
      .content__img {
        &.ko {
          background-image: url(../../assets/img/dashboard/free_trial_ko3.png);
        }
        &.ja {
          background-image: url(../../assets/img/dashboard/free_trial_ja3.png);
        }
        &.en {
          background-image: url(../../assets/img/dashboard/free_trial_en3.png);
        }
      }
    }

    .move-guide {
      position: absolute;
      top: 15px;
      right: 15px;
      font-size: 13px;
      font-weight: bold;
      line-height: 1;
      color: #d7d7d7;
      .icon {
        transform: rotateY(180deg) translateY(-2px);
        vertical-align: text-bottom;
        margin-left: 5px;
      }
    }

    .carousel__content {
      @include flexXcenter;
      padding-top: 59px;

      .content__img {
        margin-right: 40px;
      }

      .content__desc {
        width: 270px;
        white-space: normal;
        .title {
          margin-top: 18px;
          font-size: 18px;
          font-weight: bold;
          color: #ffffff;
          white-space: nowrap;
        }
        .desc {
          margin-top: 20px;
          font-size: 14px;
          line-height: 1.5;
          color: #d7d7d7;
        }
      }
    }
  }
}
</style>
